
export default {
  isCorrect(accountNumber) {
    var email = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
    var phone = /^[1]([3-9])[0-9]{9}$/;
    if (!email.test(accountNumber)) {
      return email;
    } else if (!phone.test(accountNumber)) {
      return phone;
    }
  },
}